module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABTklEQVQ4T63Tv6vPcRTH8ccrBoNksCmiDH6VDLr/gGTwFzC4JbpIMTEaTIpNsZiYZLyZLAZKMiLr9WOSgTLQ0bk+9/bxzfd+7+A9fs45z3PO67w+scarqtM4muTktLT8K1BV23ECp7AbN7GY5N1k/l+AqtqIG7iMN3iFnziIOdzHpSTfVkCTgEXs785Jno27VVVDHqBr5pJ87/gqoKquDp0PJ/kwZbXNeIkXSeZXAVXVgc84m+ThDGGP4Dl2JllanqCqjuExtiT5tRZgyH+P20nurAAWBnH2zioeAN3sY5KLY8D5JC3UzFdVj/A1yZkx4EKSAzOr/6z8/wHnsJDk0Don6Et9Wdagqp5gH7bh7XoA2IW+1usGtCF2jAo3oU11F22o1qm/XcO9Vn+U+2naz/R0mOg6fuBKGwd7ktR4ymmArbiF49jQ1kWfeWlyxd8DD4QsmUd4EwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/info.png
// module id = 8Q6I
// module chunks = 2